import React, {
  useEffect,
  useState
} from "react";

import {
  useParams,
  useNavigate
} from "react-router-dom";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

import {
  FaSchool,
  FaArrowRight
} from "react-icons/fa";

const StudentTcSession = () => {
  const [open, setOpen] =
    useState(false);

  const [classes, setClasses] =
    useState([]);

  const { id } =
    useParams();

  const navigate =
    useNavigate();

  useEffect(() => {
    fetch(
      `https://stjosephweb.ilakshyaerp.in/api/student-tc/classes/${id}`
    )
      .then((res) =>
        res.json()
      )
      .then((data) =>
        setClasses(
          Array.isArray(data)
            ? data
            : []
        )
      );
  }, [id]);

  return (
    <>
      <Header
        toggleSidebar={() =>
          setOpen(true)
        }
      />

      <Sidebar
        isOpen={open}
        close={() =>
          setOpen(false)
        }
      />

      {/* HERO */}
      <section className="bg-[#072F5F] py-16">

        <div className="max-w-7xl mx-auto px-5 text-center">

          <h1 className="text-4xl md:text-5xl font-extrabold text-white">

            STUDENT TC

          </h1>

          <p className="text-gray-200 text-lg mt-5">

            Select Class To View
            Student Transfer Certificates

          </p>

          <div className="w-28 h-1 bg-[#D4A017] mx-auto rounded-full mt-5"></div>

        </div>

      </section>

      {/* CLASS SECTION */}
      <section className="bg-[#f7f9fc] py-16 min-h-screen">

        <div className="max-w-7xl mx-auto px-5 md:px-10">

          {/* TITLE */}
          <div className="text-center mb-16">

            <span className="text-[#D4A017] uppercase tracking-[5px] text-sm font-bold">

              Academic Classes

            </span>

            <h2 className="text-4xl md:text-5xl font-extrabold text-[#072F5F] mt-4">

              Available Classes

            </h2>

          </div>

          {/* GRID */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">

            {classes.length > 0 ? (
              classes.map(
                (item) => (
                  <div
                    key={item.id}
                    onClick={() =>
                      navigate(
                        `/student-tc/class/${item.id}`
                      )
                    }
                    className="group bg-white rounded-[30px] overflow-hidden shadow-lg hover:shadow-2xl border border-gray-100 cursor-pointer transition-all duration-500 hover:-translate-y-2"
                  >

                    {/* IMAGE */}
                    <div className="relative h-[240px] overflow-hidden">

                      <img
                        src={`https://stjosephweb.ilakshyaerp.in/uploads/student-tc/${item.cover}`}
                        alt=""
                        className="w-full h-full object-cover group-hover:scale-110 transition-all duration-700"
                      />

                      {/* OVERLAY */}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>

                      {/* CLASS NAME */}
                      <div className="absolute bottom-6 left-6">

                        <span className="bg-[#D4A017] text-white px-4 py-2 rounded-xl text-sm font-semibold shadow-lg">

                          {
                            item.class_name
                          }

                        </span>

                      </div>

                    </div>

                    {/* CONTENT */}
                    <div className="p-8">

                  

                      <h3 className="text-3xl font-extrabold text-[#072F5F]">

                        {
                          item.class_name
                        }

                      </h3>

                      <div className="w-16 h-1 bg-[#D4A017] rounded-full mt-5 mb-5"></div>

                      <p className="text-gray-600 text-lg leading-8">

                        View all student
                        transfer certificates
                        for this class.

                      </p>

                      {/* BUTTON */}
                      <div className="mt-8 inline-flex items-center gap-3 bg-[#0B4F9C] text-white px-6 py-3 rounded-2xl font-semibold shadow-lg group-hover:bg-[#072F5F] transition-all duration-300">

                        View Students

                        <FaArrowRight className="group-hover:translate-x-1 transition-all duration-300" />

                      </div>

                    </div>

                  </div>
                )
              )
            ) : (
              <div className="col-span-full">

                <div className="bg-white rounded-[35px] shadow-xl border border-gray-100 p-16 text-center">

                  <div className="w-20 h-20 rounded-full bg-[#0B4F9C]/10 text-[#0B4F9C] flex items-center justify-center text-3xl mx-auto mb-6">

                    <FaSchool />

                  </div>

                  <h3 className="text-3xl font-extrabold text-[#072F5F]">

                    No Classes Available

                  </h3>

                  <p className="text-gray-500 mt-4 text-lg">

                    Classes will appear here soon.

                  </p>

                </div>

              </div>
            )}

          </div>

        </div>

      </section>

      <Footer />
    </>
  );
};

export default StudentTcSession;